import {
  ADD_TO_CART,
  ADD_TO_CART_FULFILLED,
  ADD_TO_CART_REJECTED,
} from 'b2b-apps/shop/cart/redux/addToCart/actionTypes';
import {
  AddToCartAction,
  AddToCartFulfilledAction,
  AddToCartRejectedAction,
} from 'b2b-apps/shop/cart/redux/addToCart/types';

export const addToCart = (
  sku: string,
  quantity: number,
  stockCount: number,
): AddToCartAction => ({
  type: ADD_TO_CART,
  payload: {
    sku,
    quantity,
    stockCount,
  },
});

export const addToCartFulfilled = (sku: string, quantity: number): AddToCartFulfilledAction => ({
  type: ADD_TO_CART_FULFILLED,
  payload: {
    sku,
    quantity,
  },
});

export const addToCartRejected = (): AddToCartRejectedAction => ({
  type: ADD_TO_CART_REJECTED,
});
